import CheckoutItem from '../../components/Checkout/checkout.component';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import {
  selectCartItems,
  selectCartTotal,
} from '../../store/cart/cart.selector';
import { selectCurrentUser } from '../../store/user/user.selector';
import './checkout.style.css';

import { Button } from 'react-bootstrap';

import Footer from '../../components/Footer/footer.component';
import { Fragment } from 'react';

import GrowSpinner from '../../components/Spinner/grow-spinner/grow-spinner.component';
import { useState } from 'react';

import { Helmet } from 'react-helmet-async';
import FooterNew from '../../components/Footer/section-footer';

const Checkout = () => {
  const [showSpinner, setShowSpinner] = useState(false);

  const cartItems = useSelector(selectCartItems);

  const cartTotal = useSelector(selectCartTotal);

  const currentUser = useSelector(selectCurrentUser);

  const navigate = useNavigate();

  const checkoutBillingHandler = () => {
    setShowSpinner(true);
    navigate('/checkout-billing-address');
  };

  return (
    <Fragment>
      <Helmet>
        <title>Checkout Page | Ahguide Shopping Cart </title>
        <meta
          name="description"
          content="Ahguide checkout page lists all add to cart products in this single page. You can update quantity,remove and proceed to checkout."
        />
        <link rel="canonical" href="https://www.ahguide.in/checkout" />
      </Helmet>
      <div className="section">
        <div className="container">
          {cartItems.length === 0 ? (
            <div className="cart-empty-box">
              <h2 className="heading-secondary">Your Shopping Cart is empty</h2>
              {!currentUser ? (
                <div className="btn-checkout">
                  <Button href="/login" variant="warning">
                    Sign in
                  </Button>

                  <Button href="/signup" variant="light">
                    Sign up
                  </Button>
                </div>
              ) : (
                <h3 className="heading-tertiary">Add Some Items!</h3>
              )}
            </div>
          ) : (
            <>
              <h2 className="heading-secondary margin-bottom-m">Checkout</h2>
              <div className="checkout__box-data">
                <div className="checkout-box">
                  <span className="checkout-box-item">Image</span>
                  <span className="checkout-box-item">Qty</span>
                  <span className="checkout-box-item">Name</span>
                  <span className="checkout-box-item">Price</span>
                  <span className="checkout-box-item">Remove</span>
                </div>
                {cartItems.map((item) => {
                  return <CheckoutItem product={item} key={item.id} />;
                })}
              </div>
              <div className="checkout_proceed">
                <h3 className="heading-secondary">Total: Rs. {cartTotal} </h3>

                {showSpinner ? (
                  <GrowSpinner />
                ) : (
                  <button
                    onClick={checkoutBillingHandler}
                    className="checkout__btn"
                  >
                    Proceed to Checkout
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <FooterNew />
    </Fragment>
  );
};

export default Checkout;
